import { root } from './total-time-watched';

export const totalTimeWatched = {
  ...root,
};
